import http from "src/utils/http";

/**
 * Request a server-signed embed token (coach dashboard only).
 */
export async function signEmbedToken({ hide_header, hide_footer }) {
  const { data } = await http.post("/api/embed/sign", {
    hide_header: !!hide_header,
    hide_footer: !!hide_footer,
  });

  return data.token;
}

/**
 * Build `display=embeded&embed_token=...` query string for signed embed URLs.
 */
export function buildSignedEmbedQueryString(token) {
  return new URLSearchParams({
    display: "embeded",
    embed_token: token,
  }).toString();
}

/**
 * Build a full embed URL with a signed token.
 */
export async function buildSignedEmbedUrl(bookingURL, options) {
  const token = await signEmbedToken(options);
  const separator = bookingURL.includes("?") ? "&" : "?";
  return `${bookingURL}${separator}${buildSignedEmbedQueryString(token)}`;
}

/**
 * Resolve embed display flags via API (supports signed token + legacy encrypted params).
 */
export async function resolveEmbedDisplay({
  display,
  embed_token,
  header,
  footer,
}) {
  const { data } = await http.get("/api/general/embed/resolve", {
    params: {
      display,
      embed_token,
      header,
      footer,
    },
  });

  return {
    hideHeader: !!data.hide_header,
    hideFooter: !!data.hide_footer,
  };
}

/**
 * Propagate embed query params when navigating between public booking pages.
 */
export function getEmbedQueryParamsFromSearchParams(searchParams) {
  const display = searchParams.get("display");
  const embedToken = searchParams.get("embed_token");
  const header = searchParams.get("header");
  const footer = searchParams.get("footer");

  if (embedToken) {
    return new URLSearchParams({
      display: display || "embeded",
      embed_token: embedToken,
    });
  }

  const params = new URLSearchParams();
  if (display) {
    params.set("display", display);
  }
  if (header) {
    params.set("header", header);
  }
  if (footer) {
    params.set("footer", footer);
  }

  return params;
}
